/**
 * @generated SignedSource<<73346307e7744e38204ffc0e65377a09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedItemsRefetchCarousel_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedCarouselItemTile_user">;
  readonly " $fragmentType": "PdpRespSharedItemsRefetchCarousel_user";
};
export type PdpRespSharedItemsRefetchCarousel_user$key = {
  readonly " $data"?: PdpRespSharedItemsRefetchCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedItemsRefetchCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedItemsRefetchCarousel_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedCarouselItemTile_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e981cc57add8f4686e11c62f11067845";

export default node;
